import React from "react";
import { Platform } from "react-native";
const Footer = ({ children }) => (Platform.OS !== "web" ? React.createElement(React.Fragment, null, children) : null);
export { Footer };
